export default "__VITE_ASSET__f23c3309__"